<template>
    <div class="relative-article">
        <el-row>
            <el-col :span="6">
                <span>文章名称：</span>
                <el-input v-model="artName" style="width: 150px;" placeholder="请输入文章名称" clearable></el-input>
            </el-col>
            <el-col :span="8" :offset="1">
                <span>文章分类：</span>
                <el-cascader v-model="classification" placeholder="请选择" :options="sortList"
                    :props="{ expandTrigger: 'hover' }" clearable></el-cascader>
            </el-col>
            <el-col :span="6" :offset="3">
                <div class="box box-align-center box-pack-end mt-btns">
                    <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="mt12 conmmon-table">
            <dy-table :columns="columns" :table-data="tableData" ref="shTable" :reserveSelection="true"
                v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="10"
                @current-change="onCurrentChange" @selection-change="onSelectionChange"
                element-loading-text="加载中"></dy-table>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px">
                <el-button type="primary" plain @click="saveData">保存</el-button>
                <el-button type="danger" plain @click="closeDialog">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import { getList4Pop, getAllClassification } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { uniqueBy, subtractArrays } from '@/utils/utils';

var that = null;
export default {
    name: 'articleCommon',
    components: {
        DyTable
    },
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            artName: '',
            classification: '',
            tableLoading: true,
            currentPage: 1,
            options: [],
            columns: [
                {
                    type: "selection",
                    width: "55"
                },
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'id',
                    title: '文章ID'
                },
                {
                    key: 'title',
                    title: '文章名称'
                },
                {
                    key: 'classificationName',
                    title: '文章分类'
                },
            ],
            tableData: [],
            total: 0,

            sortList: [],

            resultList: [],//选择后的数据
            delData: [],//删除的数据id
            isChange: false,
        }
    },
    watch: {
        list(val) {
            that.resultList = val.map(item => {
                return {
                    ...item,
                    id: item.articleId || item.contentId || item.id
                }
            });
            that.setPage();
        }
    },
    mounted() {
        that = this;
        that.resultList = that.list.map(item => {
            return {
                ...item,
                id: item.articleId || item.contentId || item.id
            }
        });
        that.getList();
        that.getAllClassification();
    },
    methods: {
        // 重置
        resetList() {
            that.artName = '';
            that.classification = '';
            that.currentPage = 1;
            that.getList();
        },
        // 关闭弹窗
        closeDialog() {
            that.$emit('close-dialog');
        },
        // 选择后数据处理
        onSelectionChange(val) {
            if (that.isChange || val.length == 0) {
                return;
            }
            that.delData = subtractArrays(that.tableData, val, 'id');
            let allArr = uniqueBy(that.tableData.concat(that.resultList), 'id');
            that.resultList = subtractArrays(allArr, that.delData, 'id');
        },
        saveData() {
            that.$emit('save-data', that.resultList);
            that.$emit('close-dialog');
        },
        setPage() {
            // 重新设置选中状态
            that.$nextTick(() => {
                let selList = [];
                console.log('当前选择数据', that.resultList);
                that.$refs.shTable.$refs.ElTable.clearSelection();
                that.resultList.forEach((item) => {
                    const row = that.tableData.find((row) => row.id === item.id);
                    if (row) {
                        selList.push(row);
                        that.$refs.shTable.$refs.ElTable.toggleRowSelection(row, true);
                    }
                });
                that.delData = subtractArrays(that.tableData, selList, 'id');
                that.$nextTick(() => {
                    that.isChange = false;
                })
            })
        },
        onCurrentChange(val) {
            console.log(val);
            that.isChange = true;
            that.currentPage = val;
            that.getList();
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childClass != '' && arr[i].childClass != null && arr[i].childClass != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
        getAllClassification() {
            getAllClassification().then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('分类列表', ress);
                    that.sortList = that.listFor(ress);
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取文章列表
        getList() {
            that.tableLoading = true;
            let info = {
                classification: that.classification[that.classification.length - 1],
                page: that.currentPage,
                status: 1,
                pageSize: 10,
                title: that.artName
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getList4Pop(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('文章列表', ress);
                    that.tableLoading = false;
                    that.total = ress.total;
                    that.tableData = ress.list;
                    that.setPage();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>
<style scoped>
.ra-table {
    margin-top: 12px;
    margin-bottom: 22px;
}
</style>